<template>
  <template v-if="locale == 'en'">
    <svg
      v-if="size == 'big'"
      width="56"
      height="24"
      viewBox="0 0 56 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2850_38893)">
        <rect width="56" height="24" rx="12" fill="#C53838" />
        <circle cx="11" cy="12" r="3" fill="white" />
        <path
          d="M23.2526 15.4925C23.4721 15.4925 23.5819 15.6011 23.5819 15.8182V17.4301C23.5819 17.6472 23.4502 17.7558 23.1867 17.7558H18.3293C18.1098 17.7558 18 17.6472 18 17.4301V6.91181C18 6.69471 18.1098 6.58616 18.3293 6.58616H20.2558C20.4754 6.58616 20.5851 6.71642 20.5851 6.97693V15.4925H23.2526Z"
          fill="white"
        />
        <path
          d="M26.1592 17.7558C25.9397 17.7558 25.8299 17.6472 25.8299 17.4301V9.67979C25.8299 9.46269 25.9397 9.35414 26.1592 9.35414H28.0528C28.2723 9.35414 28.3821 9.4844 28.3821 9.74492V17.4301C28.3821 17.6472 28.2723 17.7558 28.0528 17.7558H26.1592ZM27.0978 8.81683C26.6257 8.81683 26.2525 8.692 25.9781 8.44234C25.7146 8.18182 25.5829 7.83447 25.5829 7.40027C25.5829 7.13976 25.6433 6.90638 25.764 6.70014C25.8848 6.48304 26.0604 6.31479 26.2909 6.19539C26.5215 6.06513 26.7904 6 27.0978 6C27.4051 6 27.6686 6.06513 27.8881 6.19539C28.1077 6.31479 28.2778 6.48304 28.3986 6.70014C28.5193 6.90638 28.5797 7.13976 28.5797 7.40027C28.5797 7.83447 28.448 8.18182 28.1845 8.44234C27.9211 8.692 27.5588 8.81683 27.0978 8.81683Z"
          fill="white"
        />
        <path
          d="M38.1826 9.35414C38.3034 9.35414 38.4022 9.40299 38.479 9.50068C38.5558 9.59837 38.5723 9.70692 38.5284 9.82633L35.7951 17.4464C35.7073 17.6527 35.5591 17.7558 35.3505 17.7558H33.671C33.4624 17.7558 33.3142 17.6527 33.2264 17.4464L30.4931 9.82633C30.4492 9.70692 30.4601 9.59837 30.526 9.50068C30.6028 9.40299 30.7071 9.35414 30.8389 9.35414H32.683C32.9026 9.35414 33.0453 9.45726 33.1111 9.6635L34.5272 14.3854L35.9762 9.6635C36.0421 9.45726 36.1848 9.35414 36.4043 9.35414H38.1826Z"
          fill="white"
        />
        <path
          d="M43.9966 9.09363C44.8748 9.09363 45.6157 9.29444 46.2195 9.69607C46.8232 10.0868 47.2733 10.6459 47.5697 11.3731C47.8771 12.1004 48.0198 12.9634 47.9978 13.962C47.9759 14.1791 47.8606 14.2877 47.652 14.2877H42.4324C42.619 15.2972 43.2117 15.8019 44.2107 15.8019C44.6278 15.8019 44.9846 15.7422 45.2809 15.6228C45.5773 15.4925 45.9066 15.2754 46.2689 14.9715C46.3567 14.9064 46.4336 14.8738 46.4994 14.8738C46.5872 14.8738 46.6641 14.9172 46.7299 15.0041L47.6685 16.1113C47.7344 16.1873 47.7673 16.2632 47.7673 16.3392C47.7673 16.4261 47.7289 16.5075 47.652 16.5835C47.1361 17.0611 46.5982 17.4193 46.0384 17.6581C45.4895 17.886 44.8419 18 44.0954 18C43.2172 18 42.4543 17.8209 41.8066 17.4627C41.17 17.0936 40.6815 16.578 40.3412 15.9159C40.0009 15.2429 39.8307 14.4559 39.8307 13.555C39.8307 12.7083 40.0174 11.9484 40.3906 11.2754C40.7638 10.5916 41.2688 10.0597 41.9054 9.67979C42.5421 9.28901 43.2392 9.09363 43.9966 9.09363ZM43.9801 11.1615C43.1459 11.1615 42.6354 11.6554 42.4488 12.6432H45.4127C45.3797 12.1547 45.2425 11.7856 45.001 11.536C44.7595 11.2863 44.4192 11.1615 43.9801 11.1615Z"
          fill="white"
        />
        <rect
          x="0.5"
          y="0.5"
          width="55"
          height="23"
          rx="11.5"
          stroke="white"
          stroke-opacity="0.1"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2850_38893"
          x="-6"
          y="-6"
          width="68"
          height="36"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2850_38893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2850_38893"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
    <svg
      v-else-if="size == 'medium'"
      width="40"
      height="16"
      viewBox="0 0 40 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2850_38897)">
        <rect width="40" height="16" rx="8" fill="#C53838" />
        <circle cx="8" cy="8" r="2" fill="white" />
        <path
          d="M17.5017 10.3284C17.6481 10.3284 17.7213 10.4007 17.7213 10.5455V11.6201C17.7213 11.7648 17.6335 11.8372 17.4578 11.8372H14.2195C14.0732 11.8372 14 11.7648 14 11.6201V4.60787C14 4.46314 14.0732 4.39077 14.2195 4.39077H15.5039C15.6502 4.39077 15.7234 4.47761 15.7234 4.65129V10.3284H17.5017Z"
          fill="white"
        />
        <path
          d="M19.4395 11.8372C19.2931 11.8372 19.2199 11.7648 19.2199 11.6201V6.45319C19.2199 6.30846 19.2931 6.23609 19.4395 6.23609H20.7019C20.8482 6.23609 20.9214 6.32293 20.9214 6.49661V11.6201C20.9214 11.7648 20.8482 11.8372 20.7019 11.8372H19.4395ZM20.0652 5.87788C19.7505 5.87788 19.5017 5.79466 19.3187 5.62822C19.1431 5.45455 19.0553 5.22298 19.0553 4.93352C19.0553 4.75984 19.0955 4.60425 19.176 4.46676C19.2565 4.32203 19.3736 4.20986 19.5273 4.13026C19.681 4.04342 19.8603 4 20.0652 4C20.2701 4 20.4457 4.04342 20.5921 4.13026C20.7384 4.20986 20.8519 4.32203 20.9324 4.46676C21.0129 4.60425 21.0531 4.75984 21.0531 4.93352C21.0531 5.22298 20.9653 5.45455 20.7897 5.62822C20.614 5.79466 20.3725 5.87788 20.0652 5.87788Z"
          fill="white"
        />
        <path
          d="M27.4551 6.23609C27.5356 6.23609 27.6014 6.26866 27.6527 6.33379C27.7039 6.39892 27.7149 6.47128 27.6856 6.55088L25.8634 11.6309C25.8048 11.7684 25.706 11.8372 25.567 11.8372H24.4473C24.3083 11.8372 24.2095 11.7684 24.1509 11.6309L22.3287 6.55088C22.2994 6.47128 22.3068 6.39892 22.3507 6.33379C22.4019 6.26866 22.4714 6.23609 22.5592 6.23609H23.7887C23.935 6.23609 24.0302 6.30484 24.0741 6.44234L25.0181 9.59023L25.9841 6.44234C26.028 6.30484 26.1232 6.23609 26.2695 6.23609H27.4551Z"
          fill="white"
        />
        <path
          d="M31.3311 6.06242C31.9165 6.06242 32.4105 6.19629 32.813 6.46405C33.2155 6.72456 33.5155 7.09724 33.7131 7.58209C33.918 8.06694 34.0132 8.64225 33.9985 9.30801C33.9839 9.45274 33.9071 9.52511 33.768 9.52511H30.2882C30.4126 10.1981 30.8078 10.5346 31.4738 10.5346C31.7519 10.5346 31.9897 10.4948 32.1873 10.4152C32.3849 10.3284 32.6044 10.1836 32.8459 9.98101C32.9045 9.93759 32.9557 9.91588 32.9996 9.91588C33.0582 9.91588 33.1094 9.94483 33.1533 10.0027L33.779 10.7408C33.8229 10.7915 33.8449 10.8422 33.8449 10.8928C33.8449 10.9507 33.8192 11.005 33.768 11.0556C33.4241 11.374 33.0655 11.6129 32.6922 11.7721C32.3263 11.924 31.8946 12 31.3969 12C30.8115 12 30.3029 11.8806 29.8711 11.6418C29.4466 11.3958 29.121 11.052 28.8941 10.6106C28.6673 10.1619 28.5538 9.63727 28.5538 9.03664C28.5538 8.47219 28.6782 7.96563 28.9271 7.51696C29.1759 7.06106 29.5125 6.70647 29.937 6.45319C30.3614 6.19267 30.8261 6.06242 31.3311 6.06242ZM31.3201 7.44098C30.7639 7.44098 30.4236 7.77024 30.2992 8.42877H32.2751C32.2532 8.10312 32.1617 7.85708 32.0007 7.69064C31.8397 7.5242 31.6128 7.44098 31.3201 7.44098Z"
          fill="white"
        />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="15"
          rx="7.5"
          stroke="white"
          stroke-opacity="0.1"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2850_38897"
          x="-6"
          y="-6"
          width="52"
          height="28"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2850_38897"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2850_38897"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
    <svg
      v-else
      width="36"
      height="14"
      viewBox="0 0 36 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2850_38903)">
        <rect width="36" height="14" rx="7" fill="#C53838" />
        <circle cx="7.5" cy="7" r="1.5" fill="white" />
        <path
          d="M15.9765 9.03732C16.1009 9.03732 16.1631 9.10064 16.1631 9.22728V10.1676C16.1631 10.2942 16.0884 10.3575 15.9392 10.3575H13.1866C13.0622 10.3575 13 10.2942 13 10.1676V4.03189C13 3.90525 13.0622 3.84193 13.1866 3.84193H14.2783C14.4027 3.84193 14.4649 3.91791 14.4649 4.06988V9.03732H15.9765Z"
          fill="white"
        />
        <path
          d="M17.6236 10.3575C17.4991 10.3575 17.4369 10.2942 17.4369 10.1676V5.64654C17.4369 5.5199 17.4991 5.45658 17.6236 5.45658H18.6966C18.821 5.45658 18.8832 5.53257 18.8832 5.68453V10.1676C18.8832 10.2942 18.821 10.3575 18.6966 10.3575H17.6236ZM18.1554 5.14315C17.8879 5.14315 17.6764 5.07033 17.5209 4.9247C17.3716 4.77273 17.297 4.57011 17.297 4.31683C17.297 4.16486 17.3312 4.02872 17.3996 3.90841C17.468 3.78177 17.5676 3.68363 17.6982 3.61398C17.8288 3.53799 17.9812 3.5 18.1554 3.5C18.3296 3.5 18.4789 3.53799 18.6033 3.61398C18.7277 3.68363 18.8241 3.78177 18.8925 3.90841C18.9609 4.02872 18.9952 4.16486 18.9952 4.31683C18.9952 4.57011 18.9205 4.77273 18.7712 4.9247C18.6219 5.07033 18.4167 5.14315 18.1554 5.14315Z"
          fill="white"
        />
        <path
          d="M24.4368 5.45658C24.5052 5.45658 24.5612 5.48508 24.6048 5.54206C24.6483 5.59905 24.6576 5.66237 24.6328 5.73202L23.0839 10.1771C23.0341 10.2974 22.9501 10.3575 22.8319 10.3575H21.8802C21.762 10.3575 21.6781 10.2974 21.6283 10.1771L20.0794 5.73202C20.0545 5.66237 20.0607 5.59905 20.0981 5.54206C20.1416 5.48508 20.2007 5.45658 20.2754 5.45658H21.3204C21.4448 5.45658 21.5257 5.51674 21.563 5.63704L22.3654 8.39146L23.1865 5.63704C23.2238 5.51674 23.3047 5.45658 23.4291 5.45658H24.4368Z"
          fill="white"
        />
        <path
          d="M27.7314 5.30461C28.229 5.30461 28.6489 5.42176 28.991 5.65604C29.3332 5.88399 29.5882 6.21009 29.7562 6.63433C29.9303 7.05857 30.0112 7.56197 29.9988 8.14451C29.9863 8.27115 29.921 8.33447 29.8028 8.33447H26.845C26.9507 8.92334 27.2866 9.21778 27.8527 9.21778C28.0891 9.21778 28.2912 9.18295 28.4592 9.1133C28.6272 9.03732 28.8138 8.91068 29.019 8.73338C29.0688 8.69539 29.1123 8.67639 29.1497 8.67639C29.1994 8.67639 29.243 8.70172 29.2803 8.75238L29.8121 9.39824C29.8495 9.44256 29.8681 9.48689 29.8681 9.53121C29.8681 9.58187 29.8464 9.62936 29.8028 9.67368C29.5105 9.95229 29.2057 10.1612 28.8884 10.3005C28.5774 10.4335 28.2104 10.5 27.7874 10.5C27.2898 10.5 26.8574 10.3955 26.4904 10.1866C26.1296 9.97128 25.8528 9.67052 25.66 9.28426C25.4672 8.89168 25.3708 8.43261 25.3708 7.90706C25.3708 7.41316 25.4765 6.96993 25.688 6.57734C25.8995 6.17843 26.1856 5.86816 26.5464 5.64654C26.9072 5.41859 27.3022 5.30461 27.7314 5.30461ZM27.7221 6.51086C27.2493 6.51086 26.9601 6.79896 26.8543 7.37517H28.5338C28.5152 7.09023 28.4374 6.87495 28.3006 6.72931C28.1637 6.58367 27.9709 6.51086 27.7221 6.51086Z"
          fill="white"
        />
        <rect
          x="0.5"
          y="0.5"
          width="35"
          height="13"
          rx="6.5"
          stroke="white"
          stroke-opacity="0.1"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2850_38903"
          x="-6"
          y="-6"
          width="48"
          height="26"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2850_38903"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2850_38903"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </template>
  <template v-else>
    <svg
      v-if="size == 'big'"
      width="57"
      height="24"
      viewBox="0 0 57 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2884_17912)">
        <rect width="57" height="24" rx="12" fill="#C53838" />
        <path
          d="M12.4537 13.9898V15.6299H12.2036C11.767 15.6299 11.4097 15.5254 11.1319 15.3163C11.116 16.072 11.0088 16.663 10.8103 17.0891C10.6198 17.5232 10.3181 17.8327 9.90532 18.0176C9.4925 18.2106 8.93678 18.3071 8.23816 18.3071C8.07939 18.3071 8 18.2267 8 18.0659V16.9082C8 16.7474 8.07939 16.667 8.23816 16.667H8.2858C8.54778 16.667 8.75022 16.6187 8.89312 16.5223C9.04395 16.4338 9.14716 16.2931 9.20273 16.1002C9.2583 15.9153 9.28609 15.6701 9.28609 15.3646V10.4685C9.28609 10.3077 9.36548 10.2273 9.52425 10.2273H10.8937C11.0525 10.2273 11.1319 10.3077 11.1319 10.4685V13.1456C11.1319 13.4511 11.2232 13.6682 11.4058 13.7968C11.5963 13.9255 11.9059 13.9898 12.3346 13.9898H12.4537Z"
          fill="white"
        />
        <path
          d="M23.0527 10.2273C23.2115 10.2273 23.2909 10.3077 23.2909 10.4685V15.3887C23.2909 15.5495 23.2115 15.6299 23.0527 15.6299H20.6235C20.2742 15.6299 19.9685 15.5615 19.7065 15.4249C19.4525 15.2801 19.258 15.0832 19.123 14.834C18.9325 15.0993 18.6943 15.3002 18.4085 15.4369C18.1227 15.5656 17.7933 15.6299 17.4202 15.6299H16.8486C16.4992 15.6299 16.1936 15.5575 15.9316 15.4128C15.6696 15.2681 15.4712 15.0711 15.3362 14.8219C15.1536 15.0872 14.9155 15.2882 14.6217 15.4249C14.3359 15.5615 14.0104 15.6299 13.6452 15.6299H12.4068C12.2877 15.6299 12.1964 15.5615 12.1329 15.4249C12.0694 15.2801 12.0376 15.0872 12.0376 14.846C12.0376 14.5485 12.0654 14.3315 12.121 14.1948C12.1686 14.0581 12.279 13.9898 12.4537 13.9898H13.3714C13.7445 13.9898 13.931 13.7526 13.931 13.2783V10.8302C13.931 10.6694 14.0104 10.5891 14.1692 10.5891H15.5387C15.6974 10.5891 15.7768 10.6694 15.7768 10.8302V13.1456C15.7768 13.4511 15.8681 13.6682 16.0507 13.7968C16.2412 13.9255 16.5509 13.9898 16.9795 13.9898H17.1463C17.5194 13.9898 17.7059 13.7526 17.7059 13.2783V10.8302C17.7059 10.6694 17.7853 10.5891 17.9441 10.5891H19.3136C19.4723 10.5891 19.5517 10.6694 19.5517 10.8302V13.1456C19.5517 13.4511 19.643 13.6682 19.8256 13.7968C20.0161 13.9255 20.3258 13.9898 20.7545 13.9898H21.4451V10.4685C21.4451 10.3077 21.5245 10.2273 21.6833 10.2273H23.0527ZM18.6348 7.40538C18.4522 7.40538 18.2855 7.36518 18.1346 7.28479C17.9917 7.19635 17.8766 7.07978 17.7893 6.93507C17.7099 6.79035 17.6702 6.62956 17.6702 6.45269C17.6702 6.27582 17.7099 6.11503 17.7893 5.97032C17.8766 5.8256 17.9917 5.71305 18.1346 5.63265C18.2855 5.54422 18.4522 5.5 18.6348 5.5C18.8094 5.5 18.9682 5.54422 19.1111 5.63265C19.254 5.71305 19.3652 5.8256 19.4446 5.97032C19.5319 6.11503 19.5755 6.27582 19.5755 6.45269C19.5755 6.62956 19.5319 6.79035 19.4446 6.93507C19.3652 7.07978 19.254 7.19635 19.1111 7.28479C18.9682 7.36518 18.8094 7.40538 18.6348 7.40538ZM17.5154 9.37106C17.3408 9.37106 17.182 9.33086 17.0391 9.25046C16.8962 9.16203 16.7811 9.04545 16.6937 8.90074C16.6144 8.74799 16.5747 8.58318 16.5747 8.40631C16.5747 8.23748 16.6144 8.08071 16.6937 7.93599C16.7811 7.79128 16.8962 7.67873 17.0391 7.59833C17.182 7.50989 17.3408 7.46568 17.5154 7.46568C17.6901 7.46568 17.8488 7.50989 17.9917 7.59833C18.1346 7.67873 18.2458 7.79128 18.3252 7.93599C18.4125 8.08071 18.4562 8.23748 18.4562 8.40631C18.4562 8.58318 18.4125 8.74799 18.3252 8.90074C18.2458 9.04545 18.1346 9.16203 17.9917 9.25046C17.8488 9.33086 17.6901 9.37106 17.5154 9.37106ZM19.7423 9.37106C19.5676 9.37106 19.4049 9.33086 19.254 9.25046C19.1111 9.16203 18.996 9.04545 18.9087 8.90074C18.8293 8.74799 18.7896 8.58318 18.7896 8.40631C18.7896 8.23748 18.8293 8.08071 18.9087 7.93599C18.996 7.79128 19.1111 7.67873 19.254 7.59833C19.4049 7.50989 19.5676 7.46568 19.7423 7.46568C19.9169 7.46568 20.0717 7.50989 20.2067 7.59833C20.3496 7.67873 20.4607 7.79128 20.5401 7.93599C20.6274 8.08071 20.6711 8.23748 20.6711 8.40631C20.6711 8.58318 20.6274 8.74799 20.5401 8.90074C20.4607 9.04545 20.3496 9.16203 20.2067 9.25046C20.0717 9.33086 19.9169 9.37106 19.7423 9.37106Z"
          fill="white"
        />
        <path
          d="M24.7166 7.96011C24.7166 7.79932 24.796 7.71892 24.9548 7.71892H26.3242C26.483 7.71892 26.5624 7.79932 26.5624 7.96011V12.8924C26.5624 13.2783 26.6537 13.5597 26.8363 13.7365C27.0189 13.9054 27.2888 13.9898 27.6461 13.9898V15.6299C26.9713 15.6299 26.4195 15.5535 25.9908 15.4007C25.5621 15.248 25.2406 14.9947 25.0263 14.641C24.8198 14.2873 24.7166 13.8129 24.7166 13.218V7.96011Z"
          fill="white"
        />
        <path
          d="M32.2148 13.9898V15.6299H31.9647C31.6154 15.6299 31.3098 15.5575 31.0478 15.4128C30.7858 15.2681 30.5874 15.0671 30.4524 14.8098C30.0634 15.3565 29.4283 15.6299 28.5471 15.6299H27.5944C27.4753 15.6299 27.3841 15.5615 27.3205 15.4249C27.257 15.2801 27.2253 15.0872 27.2253 14.846C27.2253 14.5485 27.2531 14.3315 27.3086 14.1948C27.3563 14.0581 27.4674 13.9898 27.6421 13.9898H27.7492C28.0668 13.9898 28.3169 13.9576 28.4995 13.8933C28.682 13.829 28.817 13.7124 28.9043 13.5436C28.9996 13.3748 29.0472 13.1255 29.0472 12.7959V10.4685C29.0472 10.3077 29.1266 10.2273 29.2854 10.2273H30.6548C30.8136 10.2273 30.893 10.3077 30.893 10.4685V13.1456C30.893 13.4511 30.9843 13.6682 31.1669 13.7968C31.3574 13.9255 31.667 13.9898 32.0957 13.9898H32.2148ZM30.0952 18.5C29.9126 18.5 29.7458 18.4558 29.595 18.3673C29.4521 18.287 29.337 18.1704 29.2497 18.0176C29.1703 17.8729 29.1306 17.7121 29.1306 17.5353C29.1306 17.3664 29.1703 17.2096 29.2497 17.0649C29.337 16.9202 29.4521 16.8036 29.595 16.7152C29.7458 16.6348 29.9126 16.5946 30.0952 16.5946C30.2698 16.5946 30.4286 16.6348 30.5715 16.7152C30.7144 16.8036 30.8255 16.9202 30.9049 17.0649C30.9922 17.2096 31.0359 17.3664 31.0359 17.5353C31.0359 17.7121 30.9922 17.8729 30.9049 18.0176C30.8255 18.1704 30.7144 18.287 30.5715 18.3673C30.4286 18.4558 30.2698 18.5 30.0952 18.5Z"
          fill="white"
        />
        <path
          d="M35.9515 9.7449C36.5151 9.7449 37.0272 9.86549 37.4877 10.1067C37.956 10.3479 38.3252 10.6936 38.5951 11.1438C38.865 11.594 39 12.1206 39 12.7236C39 13.3346 38.869 13.8612 38.607 14.3033C38.345 14.7375 37.9719 15.0671 37.4877 15.2922C37.0113 15.5173 36.4556 15.6299 35.8205 15.6299H32.1647C32.0456 15.6299 31.9543 15.5615 31.8908 15.4249C31.8273 15.2801 31.7955 15.0872 31.7955 14.846C31.7955 14.5485 31.8233 14.3315 31.8789 14.1948C31.9265 14.0581 32.0377 13.9898 32.2123 13.9898H33.2126C33.1015 13.8129 33.0181 13.624 32.9625 13.423C32.9149 13.214 32.8911 12.9768 32.8911 12.7115C32.8911 12.1246 33.026 11.6061 33.296 11.1558C33.5738 10.7056 33.9469 10.3599 34.4153 10.1187C34.8837 9.86951 35.3958 9.7449 35.9515 9.7449ZM35.9515 13.9898C36.3167 13.9898 36.6064 13.8853 36.8208 13.6763C37.0351 13.4592 37.1423 13.1376 37.1423 12.7115C37.1423 12.4301 37.0867 12.1889 36.9756 11.9879C36.8645 11.787 36.7176 11.6382 36.535 11.5417C36.3524 11.4453 36.1579 11.397 35.9515 11.397C35.7371 11.397 35.5387 11.4453 35.3561 11.5417C35.1735 11.6382 35.0266 11.787 34.9155 11.9879C34.8043 12.1889 34.7488 12.4301 34.7488 12.7115C34.7488 13.1376 34.8559 13.4592 35.0703 13.6763C35.2926 13.8853 35.5863 13.9898 35.9515 13.9898Z"
          fill="white"
        />
        <circle cx="46" cy="12" r="3" fill="white" />
        <rect
          x="0.5"
          y="0.5"
          width="56"
          height="23"
          rx="11.5"
          stroke="white"
          stroke-opacity="0.1"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2884_17912"
          x="-6"
          y="-6"
          width="69"
          height="36"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2884_17912"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2884_17912"
            result="shape"
          />
        </filter>
      </defs>
    </svg>

    <svg
      v-else-if="size == 'medium'"
      width="46"
      height="16"
      viewBox="0 0 46 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2884_17915)">
        <rect width="46" height="16" rx="8" fill="#C53838" />
        <path
          d="M9.63547 9.68367H9.73534V11.0714H9.5256C9.16605 11.0714 8.85644 10.9796 8.62672 10.8061C8.59676 12.7143 7.90762 13.3367 6.19975 13.3367C6.06991 13.3367 6 13.2653 6 13.1327V12.1531C6 12.0204 6.06991 11.949 6.19975 11.949H6.2397C6.91885 11.949 7.07865 11.5816 7.07865 10.8469V6.70408C7.07865 6.57143 7.14857 6.5 7.27841 6.5H8.42697C8.55681 6.5 8.62672 6.57143 8.62672 6.70408V8.96939C8.62672 9.5 8.92635 9.68367 9.63547 9.68367Z"
          fill="white"
        />
        <path
          d="M14.9195 4.11224C14.4601 4.11224 14.1105 3.76531 14.1105 3.30612C14.1105 2.85714 14.4601 2.5 14.9195 2.5C15.359 2.5 15.7085 2.85714 15.7085 3.30612C15.7085 3.76531 15.359 4.11224 14.9195 4.11224ZM13.9807 5.77551C13.5312 5.77551 13.1917 5.41837 13.1917 4.95918C13.1917 4.52041 13.5312 4.16327 13.9807 4.16327C14.4201 4.16327 14.7697 4.52041 14.7697 4.95918C14.7697 5.41837 14.4201 5.77551 13.9807 5.77551ZM15.0493 4.95918C15.0493 4.52041 15.3989 4.16327 15.8483 4.16327C16.2878 4.16327 16.6274 4.52041 16.6274 4.95918C16.6274 5.41837 16.2878 5.77551 15.8483 5.77551C15.3989 5.77551 15.0493 5.41837 15.0493 4.95918ZM18.6249 6.5C18.7547 6.5 18.8246 6.57143 18.8246 6.70408V10.8673C18.8246 11 18.7547 11.0714 18.6249 11.0714H16.5874C15.9882 11.0714 15.5487 10.8061 15.329 10.398C15.0094 10.8469 14.52 11.0714 13.9008 11.0714H13.4214C12.8221 11.0714 12.3727 10.8061 12.153 10.3878C11.8433 10.8469 11.344 11.0714 10.7347 11.0714H9.69602C9.48628 11.0714 9.3864 10.8061 9.3864 10.4082C9.3864 9.97959 9.41574 9.68367 9.73534 9.68367H10.505C10.8246 9.68367 10.9744 9.46939 10.9744 9.08163V7.0102C10.9744 6.87755 11.0443 6.80612 11.1742 6.80612H12.3227C12.4526 6.80612 12.5225 6.87755 12.5225 7.0102V8.96939C12.5225 9.5 12.8221 9.68367 13.5312 9.68367H13.6711C13.9907 9.68367 14.1405 9.46939 14.1405 9.08163V7.0102C14.1405 6.87755 14.2104 6.80612 14.3402 6.80612H15.4888C15.6186 6.80612 15.6885 6.87755 15.6885 7.0102V8.96939C15.6885 9.5 15.9882 9.68367 16.6973 9.68367H17.2766V6.70408C17.2766 6.57143 17.3465 6.5 17.4763 6.5H18.6249Z"
          fill="white"
        />
        <path
          d="M20.0204 9.03061V4.58163C20.0204 4.44898 20.0903 4.37755 20.2202 4.37755H21.3687C21.4986 4.37755 21.5685 4.44898 21.5685 4.58163V8.7551C21.5685 9.41837 21.8881 9.68367 22.4773 9.68367V11.0714C20.8194 11.0714 20.0204 10.5612 20.0204 9.03061Z"
          fill="white"
        />
        <path
          d="M26.2093 9.68367H26.3092V11.0714H26.0995C25.5002 11.0714 25.0508 10.8061 24.831 10.3776C24.5015 10.8469 23.9621 11.0714 23.233 11.0714H22.434C22.2243 11.0714 22.1244 10.8061 22.1244 10.4082C22.1244 9.97959 22.1544 9.68367 22.474 9.68367H22.5639C23.303 9.68367 23.6525 9.52041 23.6525 8.67347V6.70408C23.6525 6.57143 23.7224 6.5 23.8523 6.5H25.0008C25.1307 6.5 25.2006 6.57143 25.2006 6.70408V8.96939C25.2006 9.5 25.5002 9.68367 26.2093 9.68367ZM24.5314 11.8878C24.9709 11.8878 25.3204 12.2449 25.3204 12.6837C25.3204 13.1429 24.9709 13.5 24.5314 13.5C24.072 13.5 23.7224 13.1429 23.7224 12.6837C23.7224 12.2449 24.072 11.8878 24.5314 11.8878Z"
          fill="white"
        />
        <path
          d="M29.4432 6.09184C30.8514 6.09184 32 7.03061 32 8.61225C32 10.1939 30.9313 11.0714 29.3333 11.0714H26.2671C26.0574 11.0714 25.9575 10.8061 25.9575 10.4082C25.9575 9.97959 25.9875 9.68367 26.3071 9.68367H27.1461C26.9663 9.38776 26.8764 9.06122 26.8764 8.60204C26.8764 7.06122 28.0449 6.09184 29.4432 6.09184ZM29.4432 9.68367C30.0225 9.68367 30.4419 9.34694 30.4419 8.60204C30.4419 7.84694 29.9426 7.4898 29.4432 7.4898C28.9338 7.4898 28.4344 7.84694 28.4344 8.60204C28.4344 9.34694 28.8539 9.68367 29.4432 9.68367Z"
          fill="white"
        />
        <circle cx="38" cy="8" r="2" fill="white" />
        <rect
          x="0.5"
          y="0.5"
          width="45"
          height="15"
          rx="7.5"
          stroke="white"
          stroke-opacity="0.1"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2884_17915"
          x="-6"
          y="-6"
          width="58"
          height="28"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2884_17915"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2884_17915"
            result="shape"
          />
        </filter>
      </defs>
    </svg>

    <svg
      v-else-if="size == 'small'"
      width="40"
      height="14"
      viewBox="0 0 40 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2884_17918)">
        <rect width="40" height="14" rx="7" fill="#C53838" />
        <path
          d="M8.93634 8.37755H9.01701V9.51299H8.8476C8.5572 9.51299 8.30712 9.43785 8.12159 9.29592C8.09738 10.8571 7.54077 11.3664 6.16134 11.3664C6.05647 11.3664 6 11.308 6 11.1994V10.398C6 10.2894 6.05647 10.231 6.16134 10.231H6.1936C6.74215 10.231 6.87122 9.93043 6.87122 9.32931V5.9397C6.87122 5.83117 6.92769 5.77273 7.03256 5.77273H7.96025C8.06512 5.77273 8.12159 5.83117 8.12159 5.9397V7.79314C8.12159 8.22727 8.36359 8.37755 8.93634 8.37755Z"
          fill="white"
        />
        <path
          d="M13.2042 3.81911C12.8331 3.81911 12.5508 3.53525 12.5508 3.15955C12.5508 2.79221 12.8331 2.5 13.2042 2.5C13.5592 2.5 13.8415 2.79221 13.8415 3.15955C13.8415 3.53525 13.5592 3.81911 13.2042 3.81911ZM12.4459 5.17996C12.0829 5.17996 11.8086 4.88776 11.8086 4.51206C11.8086 4.15306 12.0829 3.86085 12.4459 3.86085C12.8009 3.86085 13.0832 4.15306 13.0832 4.51206C13.0832 4.88776 12.8009 5.17996 12.4459 5.17996ZM13.3091 4.51206C13.3091 4.15306 13.5914 3.86085 13.9544 3.86085C14.3094 3.86085 14.5836 4.15306 14.5836 4.51206C14.5836 4.88776 14.3094 5.17996 13.9544 5.17996C13.5914 5.17996 13.3091 4.88776 13.3091 4.51206ZM16.197 5.77273C16.3019 5.77273 16.3584 5.83117 16.3584 5.9397V9.34601C16.3584 9.45455 16.3019 9.51299 16.197 9.51299H14.5514C14.0674 9.51299 13.7124 9.29592 13.535 8.96197C13.2768 9.32931 12.8815 9.51299 12.3814 9.51299H11.9942C11.5102 9.51299 11.1472 9.29592 10.9697 8.95362C10.7196 9.32931 10.3163 9.51299 9.8242 9.51299H8.98524C8.81584 9.51299 8.73517 9.29592 8.73517 8.97032C8.73517 8.61967 8.75887 8.37755 9.01701 8.37755H9.63866C9.8968 8.37755 10.0178 8.20223 10.0178 7.88497V6.19017C10.0178 6.08163 10.0743 6.02319 10.1791 6.02319H11.1068C11.2117 6.02319 11.2682 6.08163 11.2682 6.19017V7.79314C11.2682 8.22727 11.5102 8.37755 12.0829 8.37755H12.1959C12.454 8.37755 12.575 8.20223 12.575 7.88497V6.19017C12.575 6.08163 12.6315 6.02319 12.7363 6.02319H13.664C13.7689 6.02319 13.8254 6.08163 13.8254 6.19017V7.79314C13.8254 8.22727 14.0674 8.37755 14.6401 8.37755H15.108V5.9397C15.108 5.83117 15.1645 5.77273 15.2693 5.77273H16.197Z"
          fill="white"
        />
        <path
          d="M17.3242 7.84323V4.20315C17.3242 4.09462 17.3806 4.03618 17.4855 4.03618H18.4132C18.5181 4.03618 18.5745 4.09462 18.5745 4.20315V7.61781C18.5745 8.16048 18.8327 8.37755 19.3086 8.37755V9.51299C17.9695 9.51299 17.3242 9.09555 17.3242 7.84323Z"
          fill="white"
        />
        <path
          d="M22.3229 8.37755H22.4036V9.51299H22.2342C21.7502 9.51299 21.3872 9.29592 21.2097 8.94527C20.9435 9.32931 20.5079 9.51299 19.919 9.51299H19.2736C19.1042 9.51299 19.0236 9.29592 19.0236 8.97032C19.0236 8.61967 19.0478 8.37755 19.3059 8.37755H19.3785C19.9755 8.37755 20.2578 8.24397 20.2578 7.55102V5.9397C20.2578 5.83117 20.3143 5.77273 20.4191 5.77273H21.3468C21.4517 5.77273 21.5082 5.83117 21.5082 5.9397V7.79314C21.5082 8.22727 21.7502 8.37755 22.3229 8.37755ZM20.9677 10.1809C21.3226 10.1809 21.605 10.4731 21.605 10.8321C21.605 11.2078 21.3226 11.5 20.9677 11.5C20.5966 11.5 20.3143 11.2078 20.3143 10.8321C20.3143 10.4731 20.5966 10.1809 20.9677 10.1809Z"
          fill="white"
        />
        <path
          d="M24.9349 5.43878C26.0723 5.43878 27 6.20686 27 7.50093C27 8.79499 26.1368 9.51299 24.8461 9.51299H22.3696C22.2002 9.51299 22.1195 9.29592 22.1195 8.97032C22.1195 8.61967 22.1437 8.37755 22.4019 8.37755H23.0795C22.9343 8.13544 22.8617 7.86828 22.8617 7.49258C22.8617 6.23191 23.8055 5.43878 24.9349 5.43878ZM24.9349 8.37755C25.4028 8.37755 25.7416 8.10204 25.7416 7.49258C25.7416 6.87477 25.3382 6.58256 24.9349 6.58256C24.5235 6.58256 24.1201 6.87477 24.1201 7.49258C24.1201 8.10204 24.4589 8.37755 24.9349 8.37755Z"
          fill="white"
        />
        <circle cx="32.5" cy="7" r="1.5" fill="white" />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="13"
          rx="6.5"
          stroke="white"
          stroke-opacity="0.1"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2884_17918"
          x="-6"
          y="-6"
          width="52"
          height="26"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2884_17918"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2884_17918"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </template>
</template>

<script setup>
const props = defineProps({
  size: { type: String, default: () => "big" },
});

const { locale } = useCurrentLocale();
</script>
